import React, { useContext, useEffect } from 'react';
import {
  Outlet, useLocation, useNavigate
} from 'react-router-dom';

import { NewFAContext } from '.';

interface NewFAGuardProps {
  initLoad: boolean;
  setInitLoad: (value: boolean) => void;
}

export function NewFAGuard({ initLoad, setInitLoad }: NewFAGuardProps) {
  const navigate = useNavigate();
  const location = useLocation();
    
  const { funeralArrangement } = useContext(NewFAContext);
  
  console.log('INIT LOAD', initLoad);
  
  useEffect(() => {
    console.log('NewFAGuard effect', funeralArrangement);
    setInitLoad(false);
  
    if (funeralArrangement && funeralArrangement.status === 'complete') {
      console.log('existing completed funeral arrangement', funeralArrangement);
      return navigate({
        pathname: `/people/self/life-documents/funeral-arrangements/${funeralArrangement.id}`,
        search: location.search
      }, { replace: true });
    }
  
    if (funeralArrangement && initLoad) {
      console.log('existing funeral arrangement', funeralArrangement);
      return navigate({
        pathname: '/people/self/life-documents/funeral-arrangements/new/continue',
        search: location.search
      }, { replace: true });
    }
  
    if (funeralArrangement) {
      console.log('existing draft funeral arrangement', funeralArrangement);
      return;
    }
  
    return navigate({
      pathname: '/people/self/life-documents/funeral-arrangements/new',
      search: location.search
    }, { replace: true });
  }, [ initLoad, location.search, navigate, setInitLoad, funeralArrangement ]);
  
  return <Outlet />; // Render the nested routes
}